import { useTranslation } from '@/clientWeb/i18n/LanguageContext'

/**
 * The "you cannot send here, and here is why" banner.
 *
 * Lives in its own file because two different surfaces need it and they must
 * not drift: the composer inside a thread, and the private conversation LIST,
 * which has no composer to carry the message. Without it on the list, a user
 * whose private chat was closed saw a perfectly ordinary list of conversations
 * and only found out why nothing worked after opening one.
 *
 * Names the host on purpose — "chat is disabled for you" reads like a fault
 * with the reader's own account rather than a decision someone made.
 */
export function ChatDisabledNotice({ isPrivate = false }: { isPrivate?: boolean }) {
  const t = useTranslation()

  return (
    <div className="mobile-sheet-footer border-t border-vc-panel-border px-4 py-4 bg-panelcolor flex-shrink-0">
      <div className="rounded-xl bg-slate-100 dark:bg-muted px-4 py-3 text-center text-sm text-slate-800 dark:text-foreground">
        {isPrivate ? t('panels.privateChatDisabledByHost') : t('panels.chatDisabledByHost')}
      </div>
    </div>
  )
}
